import { useEffect, useState } from "react";
import { api } from "../utils/api";

export const useInitiativeProgressUpdates = (initiative) => {
  const [progressUpdates, setProgressUpdates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!initiative) {
      setProgressUpdates([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    setError(null);
    api
      .get(`/initiatives/${initiative.id}/progress-updates`)
      .then(({ data }) => {
        if (!cancelled) setProgressUpdates(data);
      })
      .catch((err) => {
        if (!cancelled)
          setError(err.message || "Failed to load progress updates");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [initiative]);

  return { progressUpdates, loading, error };
};
